import { render } from "./nomocracyScreen.vue?vue&type=template&id=72026d6e"
import script from "./nomocracyScreen.vue?vue&type=script&lang=js"
export * from "./nomocracyScreen.vue?vue&type=script&lang=js"

import "./nomocracyScreen.vue?vue&type=style&index=0&id=72026d6e&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__